export function OrganizationSchema() {
  return {
    '@context': 'http://schema.org',
    '@type': 'Organization',
    name: 'Mosaic Crop Nutrition',
    url: 'https://www.cropnutrition.com',
    logo: 'https://www.cropnutrition.com/mosaic.png',
    sameAs: [
      'https://www.facebook.com/MosaicCropNutrition',
      'https://twitter.com/crop_nutrition',
      'https://www.youtube.com/user/CropNutrition'
    ]
  };
}